import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../icon/icon";
export var CLASSNAME = 'Icons-new-product';
export var ID = 'icon-new-product';
/* eslint-disable max-len */

export var SVGNewProduct = function SVGNewProduct() {
  return React.createElement("symbol", {
    id: ID,
    viewBox: "0 0 68 67"
  }, React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    id: "new_product",
    transform: "translate(-5.000000, -4.000000)"
  }, React.createElement("rect", {
    x: "0",
    y: "0",
    width: "76",
    height: "76"
  }), React.createElement("path", {
    d: "M38.0473227,23.9923 C39.7173227,22.7413 41.7913227,22.0003 44.0383227,22.0003 C49.5603227,22.0003 54.0383227,26.4763 54.0383227,32.0003 C54.0383227,37.5223 49.5603227,42.0003 44.0383227,42.0003 C43.7033227,42.0003 43.3733227,41.9833 43.0473227,41.9513",
    stroke: "#6D6565",
    strokeWidth: "2"
  }), React.createElement("path", {
    d: "M19.5998227,20.506 C23.9168227,11.342 33.2368227,5 44.0378227,5 C58.9498227,5 71.0378227,17.088 71.0378227,32 C71.0378227,46.911 58.9498227,59 44.0378227,59 C43.7058227,59 43.3758227,58.993 43.0468227,58.982 M6,19.9998 L6,69.9998 L44,69.9998 L44,28.9998 L35,19.9998 L6,19.9998 Z M35,19.9998 L35,28.9998 L44,28.9998",
    stroke: "#6D6565",
    strokeWidth: "2"
  }), React.createElement("path", {
    d: "M19,56.047 C19,57.369 17.928,58.442 16.606,58.442 C15.283,58.442 14.212,57.369 14.212,56.047 C14.212,54.725 15.283,53.653 16.606,53.653 C17.928,53.653 19,54.725 19,56.047 Z",
    stroke: "#6D6565",
    strokeWidth: "2"
  }), React.createElement("path", {
    d: "M32.0079707,53.6534 C32.0079707,54.9754 30.9359707,56.0474 29.6139707,56.0474 C28.2919707,56.0474 27.2199707,54.9754 27.2199707,53.6534 C27.2199707,52.3314 28.2919707,51.2584 29.6139707,51.2584 C30.9359707,51.2584 32.0079707,52.3314 32.0079707,53.6534 Z",
    stroke: "#6D6565",
    strokeWidth: "2"
  }), React.createElement("polyline", {
    stroke: "#6D6565",
    strokeWidth: "2",
    points: "19 56.047 19 38.9998 32 35.9998 32 53.6568"
  }), React.createElement("path", {
    d: "M19,42.9998 L32,39.9998 L19,42.9998 Z",
    stroke: "#6D6565",
    strokeWidth: "2"
  }))));
};
/* eslint-disable max-len */

var NewProduct = function NewProduct(props) {
  return React.createElement(Icon, {
    id: ID,
    className: props.className ? "".concat(props.className, " ").concat(CLASSNAME) : CLASSNAME,
    onClick: props.onClick,
    svg: SVGNewProduct
  });
};

NewProduct.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default NewProduct;